// extracted by mini-css-extract-plugin
export var banner = "_nq-0";
export var settingRow = "_nq-2";
export var titleIcon = "_nq-1";